import { useEffect, useState } from 'react';
import { formatSavedAgo } from './formatSavedAgo';

interface SavedAgoProps {
  /** ISO timestamp of the last save; null means the board has unsaved state. */
  savedAt: string | null;
}

/**
 * "saved 3s ago" / "unsaved" pill. Self-updating: an interval re-renders
 * once a second for the first minute, then once a minute thereafter, so
 * the relative-time string stays fresh without the parent driving the
 * tick.
 */
export function SavedAgo({ savedAt }: SavedAgoProps) {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!savedAt) return;
    const ms = Date.now() - new Date(savedAt).getTime();
    // Re-tick every second for the first minute (so "5s" → "6s" reads
    // live), then every minute after that. The setInterval handle is
    // refreshed when this effect re-runs on savedAt change.
    const interval = ms < 60_000 ? 1000 : 60_000;
    const id = window.setInterval(() => setTick((t) => t + 1), interval);
    return () => window.clearInterval(id);
  }, [savedAt]);
  return (
    <span className="thud__hint">
      {savedAt ? `saved ${formatSavedAgo(savedAt)}` : 'unsaved'}
    </span>
  );
}
